import { reactMount } from '@/lib/reactMount'
import { ChevronRightIcon } from '@heroicons/react/20/solid'
import { useRef } from 'react'

export const breadcrumbBlock = ({ dataset, umbraco }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
  umbraco ||= umbracoRef.current
  const theme = umbraco.Theme || 'dark'

  if (!umbraco) return null

  if (umbraco.DisableBreadcrumbs) return null

  const breadcrumbs = umbraco.Breadcrumbs

  return (
    // This block should not render background colour instead it should display over the top of the first content
    <div data-theme={theme} className='isolate absolute top-[86px] z-40 w-full'>
      <nav aria-label='Breadcrumb' className='mx-auto max-w-7xl lg:grid lg:grid-cols-12 lg:gap-x-8 '>
        <ol role='list' className='col-span-full flex items-center px-4 py-6 sm:px-6 lg:px-6'>
          {breadcrumbs.map((crumb, idx) => (
            <li key={crumb.Name} className='flex items-center last:pointer-events-none text-[--breadcrumb-text] mr-1.5 last:text-[--breadcrumb-active-text]'>
              <>
                {idx !== 0 && (
                  <ChevronRightIcon aria-hidden='true' className='size-4 shrink-0 text-[--breadcrumb-chevron] mr-1.5' />
                )}
                <a
                  href={crumb.Url}
                  aria-current={idx === breadcrumbs.length - 1 ? 'page' : undefined}
                  className='text-[10px] uppercase font-extrabold hover:opacity-80'
                >
                  {crumb.Name}
                </a>
              </>
            </li>
          ))}
        </ol>
      </nav>
    </div>
  )
}

reactMount('breadcrumbBlock', breadcrumbBlock)
